var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"space-y-4 border-b border-slate-400 px-6 py-4",class:{ 'bg-ink-300': _vm.isAggregate }},[_c('trend-title',_vm._b({on:{"update-filter":_vm.updateFilter}},'trend-title',_vm.$props,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }